import { render, staticRenderFns } from "./UserListAdd.vue?vue&type=template&id=6be3b06a&scoped=true&"
import script from "./UserListAdd.vue?vue&type=script&lang=js&"
export * from "./UserListAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserListAdd.vue?vue&type=style&index=0&id=6be3b06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3b06a",
  null
  
)

export default component.exports